module.exports = __webpack_public_path__ + "img/arrow.19e977c0.svg";